export const alterationsEn: Record<string, string> = {
  // Filter labels (used across pages)
  'filters.category': 'Category',
  'filters.allCategories': 'All Categories',
  'filters.brand': 'Brand',
  'filters.allBrands': 'All Brands',
  'filters.color': 'Color',
  'filters.allColors': 'All Colors',
  'filters.sellingPriceRange': 'Selling Price Range (€)',
  'filters.costPriceRange': 'Cost Price Range (€)',
  'filters.min': 'Min',
  'filters.max': 'Max',
  'filters.advancedFilters': 'Advanced Filters',
  'filters.sizeRange': 'Size Range',
  'filters.allSizes': 'All Sizes',
  'filters.supplier': 'Supplier',
  'filters.allSuppliers': 'All Suppliers',
  'filters.stockOptions': 'Stock Options',
  'filters.trackStock': 'Track Stock',
  'filters.allowNegative': 'Allow Negative',
  'filters.imageFilter': 'Image Filter',
  'filters.allProducts': 'All Products',
  'filters.stockAvailableRange': 'Stock Available Range',
  'filters.quantityOnHandRange': 'Quantity on Hand Range',

  // Alterations page toasts
  'alterations.toast.fetchError': 'Failed to fetch alteration tasks',
  'alterations.toast.taskMoved': 'Task moved successfully',
  'alterations.toast.moveError': 'Failed to move task',
  'alterations.modal.successTitle': 'Success',
  'alterations.modal.errorTitle': 'Error',
  'alterations.modal.taskUpdatedSuccess': 'Task updated successfully',
  'alterations.modal.taskUpdateError': 'Failed to update task',
  'alterations.modal.unknownCustomer': 'Unknown Customer',
  'alterations.modal.orderLine': 'Order #{orderNo} - {customerName}',
  'alterations.modal.photosTab': 'Photos',
  'alterations.modal.timeTrackingTab': 'Time Tracking',
  'alterations.modal.taskTitle': 'Task Title',
  'alterations.modal.stage': 'Stage',
  'alterations.modal.selectStage': 'Select stage',
  'alterations.modal.assignee': 'Assignee',
  'alterations.modal.selectAssignee': 'Select assignee',
  'alterations.modal.unassigned': 'Unassigned',
  'alterations.modal.descriptionAndNotes': 'Description & Notes',
  'alterations.modal.descriptionPlaceholder': 'Add task details and internal notes...',
  'alterations.modal.taskInformation': 'Task Information',
  'alterations.modal.taskType': 'Task Type:',
  'alterations.modal.priority': 'Priority:',
  'alterations.modal.priorityHigh': 'High',
  'alterations.modal.priorityMedium': 'Medium',
  'alterations.modal.priorityLow': 'Low',
  'alterations.modal.created': 'Created:',
  'alterations.modal.beforePhotos': 'Before Photos ({count})',
  'alterations.modal.beforePhotoAlt': 'Before {index}',
  'alterations.modal.noBeforePhotos': 'No before photos',
  'alterations.modal.afterPhotos': 'After Photos ({count})',
  'alterations.modal.afterPhotoAlt': 'After {index}',
  'alterations.modal.noAfterPhotos': 'No after photos',
  'alterations.modal.totalTimeSpent': 'Total time spent on this task',
  'alterations.modal.startTimer': 'Start Timer',
  'alterations.modal.stopTimer': 'Stop Timer',
  'alterations.modal.timerRunning': 'Timer running: {elapsed} elapsed',
  'alterations.modal.manualTimeEntry': 'Manual Time Entry',
  'alterations.modal.minutesPlaceholder': 'Minutes',
  'alterations.modal.minutesTotal': 'minutes total',
  'alterations.modal.saveChanges': 'Save Changes',
};
